$(document).ready(function(){

    function changePrice(){
    $('body .spf-product__variants').on('change',function(){
      var element = $(this).find('option:selected'); 
      var price = element.attr("data-price");
      var c_price = element.attr("data-compare_at_price");
      var data_available_ = element.attr("data-available");
      // console.log('price',price);
      // console.log('c_price',c_price);
      $(this).parents('.spf-product-card').find('.spf-product-card__price-wrapper .spf-product-card__price').text(price);
      if(c_price == '$0.00' || c_price == '$0'){
        $(this).parents('.spf-product-card').find('.spf-product-card__price-wrapper .spf-product-card__oldprice').text(c_price).addClass('hide');
      }else{
        $(this).parents('.spf-product-card').find('.spf-product-card__price-wrapper .spf-product-card__oldprice').text(c_price).removeClass('hide');
      }
     
        $(this).parents('.spf-product-card').find('.spf-product-card__price-wrapper .spf-product-card__saleprice').text(price);

      if(data_available_ == 'true') {
        $(this).parents('.spf-product-card').find('button.spf-product__form-btn-addtocart').prop('disabled', false);
        $(this).parents('.spf-product-card').find('button.spf-product__form-btn-addtocart span.text').text("Add to cart");
      } else {
        $(this).parents('.spf-product-card').find('button.spf-product__form-btn-addtocart').prop('disabled', true);
        $(this).parents('.spf-product-card').find('button.spf-product__form-btn-addtocart span.text').text("Sold out");
      }
    })
    }
    
    setTimeout(function(){
      
    changePrice();
    },5000)
    
    $( ".gf-loadmore-btn" ).click(function() {
      setTimeout(function(){
    changePrice();
    },5000)
      //changePrice();
  });
    
    
    $(window).scroll(function(){
    var windowTop = $(this).scrollTop() + 2000;
      
    var eleHeight=  $('#gf-products').height();
      
      if(windowTop > eleHeight)
      changePrice();
      
  });
    
    
  })